import React, { lazy, Suspense } from "react";
import { Box } from "@mui/material";
import Navbar from "../widgets/navbar/navbar";
import MenuDrawer from "../../../Components/Widgets/MenuDrawer";
import SubMenuDrawer from "../../../Components/Widgets/SubMenuDrawer";
import Footer from "../widgets/footer";
import RevealSection from "../widgets/common/reveal-section";
import { HeroPlaceholder } from "../widgets/common/home-section-skeleton";
import { useTheme } from "@mui/material/styles";

const HomeHeroSlide = lazy(
  () => import("../../default/widgets/sliders/home-hero-slide"),
);

const ToggleProductsShowcaseSection = lazy(
  () =>
    import("../../default/widgets/sliders/toggle-products-showcase-section"),
);

const Grid2Section = lazy(
  () => import("../../default/widgets/sliders/grid-2-section"),
);

const GiftCardsSection = lazy(
  () => import("../../default/widgets/sliders/gift-cards-section"),
);

const RecentlyViewed = lazy(
  () => import("../../../Components/Widgets/RecentlyViewed"),
);

const ExportDefault = (props) => {
  const theme = useTheme();
  const gap = { xs: 6, md: 8 };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Navbar bg_color="#fff" {...props} />
      <MenuDrawer {...props} />
      <SubMenuDrawer {...props} />
      <Suspense fallback={<HeroPlaceholder theme={theme} />}>
        <HomeHeroSlide
          {...{
            ...props,
            mb: gap,
            slide: {
              videoPath:
                "https://files.automatapp.com/konstantino/assets/summer-video.mp4",
              title: "GIFTS WITH PRESENCE",
              desc: "Explore signature designs crafted to mark every occasion with character, elegance, and intention.",
              descMaxWidth: { xs: "unset", sm: "900px" },
              buttons: [
                {
                  name: "GIFTS FOR HER",
                  url: "/women/gift/over-1",
                },
                { name: "GIFTS FOR HIM", url: "/men/gift/over-1" },
              ],
            },
          }}
        />
      </Suspense>

      <RevealSection id="giftsProducts" variant="products">
        <ToggleProductsShowcaseSection
          {...{
            ...props,
            mb: gap,
            tabs: [
              {
                slug: "women",
                name: "WOMEN'S",
                url: "/women/gift/over-1",
                params: {
                  pageAmount: 100,
                  curation: "best-sellers",
                  gender: "women",
                  type: "ring,bracelet,earrings,pendant,necklace",
                },
                amount: 15,
                shuffle: true,
                productDisplay: {
                  showName: false,
                  showCollection: false,
                  showPrice: false,
                  showGems: false,
                  showCuration: true,
                },
              },
              {
                slug: "men",
                name: "MEN'S",
                url: "/men/gift/over-1",
                params: {
                  pageAmount: 100,
                  curation: "best-sellers",
                  gender: "men",
                  type: "ring,bracelet,earrings,pendant,necklace",
                },
                amount: 15,
                shuffle: true,
                productDisplay: {
                  showName: false,
                  showCollection: false,
                  showPrice: false,
                  showGems: false,
                  showCuration: true,
                },
              },
            ],
          }}
        />
      </RevealSection>

      <RevealSection id="grid2Section">
        <Grid2Section
          {...{
            ...props,
            mb: gap,
            ...{
              title: "SHOP BY PRICE",
              imagesPath: "/marketing/main",
              slides: [
                {
                  slug: "womens-gifts",
                  title: "WOMEN'S",
                  desc: "Explore women’s designs by price.",
                  url: "/women/gift/under-500",
                  buttons: [
                    {
                      name: "UNDER $500",
                      url: "/women/gift/under-500",
                    },
                    {
                      name: "UNDER $1000",
                      url: "/women/gift/under-1000",
                    },
                    {
                      name: "UNDER $2500",
                      url: "/women/gift/under-2500",
                    },
                    {
                      name: "Luxe Gifts",
                      url: "/women/gift/over-2500",
                    },
                  ],
                },
                {
                  slug: "mens-gifts",
                  title: "MEN'S",
                  desc: "Explore men’s designs by price.",
                  url: "/men/gift/under-500",
                  buttons: [
                    {
                      name: "UNDER $500",
                      url: "/men/gift/under-500",
                    },
                    {
                      name: "UNDER $1000",
                      url: "/men/gift/under-1000",
                    },
                    {
                      name: "UNDER $2500",
                      url: "/men/gift/under-2500",
                    },
                    {
                      name: "Luxe Gifts",
                      url: "/men/gift/over-2500",
                    },
                  ],
                },
              ],
            },
          }}
        />
      </RevealSection>

      <RevealSection id="giftCards">
        <GiftCardsSection {...{ ...props, mb: gap, smallSpacing: true }} />
      </RevealSection>

      <RevealSection id="recentlyViewed" variant="products">
        <RecentlyViewed
          {...props}
          mb={gap}
          title="ITEMS YOU VIEWED"
          productDisplay={{
            showName: false,
            showCollection: false,
            showPrice: false,
            showGems: false,
            showCuration: true,
          }}
        />
      </RevealSection>

      <Footer {...props} />
    </Box>
  );
};

export default ExportDefault;
